export default __webpack_public_path__ + "static/media/SFProDisplay-Regular.7ee14c63.woff";